import {AppState} from './../../../store';
import {createSelector} from 'reselect';
import {appConfig} from '@stencil/hotels-config';
export const destinationSelector = (state: AppState) => state.destinations || {};
export const destinationDataSelector = (state: AppState) => state.destinations || {};

export const destinationsSelectorFn = createSelector(destinationSelector, item => item);

export const trendingDestinationsSelectorFn = createSelector(destinationDataSelector, item => {
  const {data: trendingDestinationsFromState, isLoading: isTrendingDestinationsLoading} = item;
  if (!trendingDestinationsFromState) {
    return {
      trendingCityList: [],
      domesticTrendingCityList: [],
      internationalTrendingCityList: [],
      text: '',
      isTrendingDestinationsLoading,
      trendingDestinationsFromState: {},
    };
  }

  const {trending_destinations = {}, meta_config = {}} = trendingDestinationsFromState;
  const {text = '', id_list = []} = trending_destinations;
  const {entities_data = {}} = meta_config;

  const cityList = id_list
    .map(item => entities_data[item])
    .filter(
      item =>
        item &&
        item['go_data'] &&
        item['img_processed'] &&
        item['img_processed']['landscape'] &&
        item['img_processed']['landscape']['jpg'] &&
        item['img_processed']['landscape']['jpg']['g'],
    );

  const domesticCityList = cityList.filter(
    item => item?.cnt_code === appConfig.countryTextMap.india.key,
  );
  const internationalCityList = cityList.filter(
    item => item?.cnt_code !== appConfig.countryTextMap.india.key && item?.cnt_code !== null,
  );

  let trendingCityList = [],
    domesticTrendingCityList = [],
    internationalTrendingCityList = [];

  // Slicing in multiple of 3 as per the UI
  //taking slice once to avoid recomputation
  let cityListSlice = cityList.slice(0, 6);
  let domesticListSlice = domesticCityList.slice(0, 6);
  let internationalListSlice = internationalCityList.slice(0, 6);

  // For common trending cities
  trendingCityList =
    cityListSlice.length % 3 == 0 ? cityListSlice : cityList.slice(0, -(cityListSlice.length % 3));

  // For domestic trending cities
  domesticTrendingCityList =
    domesticListSlice.length % 3 == 0
      ? domesticListSlice
      : domesticListSlice.slice(0, -(domesticListSlice.length % 3));

  // For interantional trending cities
  internationalTrendingCityList =
    internationalListSlice.length % 3 == 0
      ? internationalListSlice
      : internationalListSlice.slice(0, -(internationalListSlice.length % 3));

  return {
    trendingCityList,
    domesticTrendingCityList,
    internationalTrendingCityList,
    text,
    isTrendingDestinationsLoading,
    trendingDestinationsFromState,
  };
});

export const trendingDestinationsSelectorFnV2 = createSelector(
  destinationDataSelector,
  item => item.dataV2 || [],
);
